import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const SoftwareTA = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/travel-website-development.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					Software for Travel Agency
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					Software for Travel Agency
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Software for Travel Agency
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/software-development.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								Travel Technology has made travelling much more simpler/easier
								in comparison to earlier life. Everything that you are looking
								for is on the tip of your fingers and a just click away from
								you. So travel agencies should consider these circumstances and
								upgrade their Offline Travel Management Company to Online Travel
								Management Company. Travel technology is the part of IT
								industry, which delivers travel related software to various
								travel agencies, and companies through technology enabled Travel
								Portals by making Hotel Booking System, Flight Booking System,
								Car Booking System and Bus Booking System etc. Travel technology
								includes every travel need and various other things which are
								easy to use for both the Travel Agency and the Travellers. There
								are many software or online solutions for Travel and Tourism
								Industry like Online B2C Booking System, B2B Booking System,
								Travel White Label Solution, Travel API Integration, Tours
								Package website or Inventory Management System etc. which makes
								your Online Travel Portal More easier to use and manage. Online
								Travel agencies prefers Travel Software as it makes managing
								their services easily. These solutions cover front office and
								back office activities. Agencies use this type of software to
								promote their offerings to current and prospective travellers.
								Travel agency software spans across the full customer engagement
								cycle, from bookings, to billing, to customer feedback and
								review. Travel Technology software offers multiple aspects of
								travel needs for travellers including flights, hotels, or
								bus/car.
							</p>
							<br />
							<p>
								Arya Aviation provides a web-based Travel Technology Software
								that helps travel agencies maximize their online bookings while
								reducing their administrative costs. You can sell your travel
								products via multiple channels (B2C Travel Portal, B2B Travel
								Portal and B2B2B Travel Portal) and efficiently manage your
								operations through our advanced travel management module.
							</p>
							<br />
							<p>
								It is completely game changing software in Travel Industry for
								making your business growth, it is truly scalable and can also
								easily be operated and easy to maintain your travel business. A
								unique aspect of our solution is that we also offer Travel APIs
								that allow travel agencies to get live data from various
								suppliers. Our technology team has 10+ years of experience in
								travel technology by building their own front ends for web and
								mobile of customers choice.
							</p>
							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default SoftwareTA;
